import React, { memo } from 'react';
import { string } from 'prop-types';
import { merge } from 'lodash';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { CLICKED_ON_ADD_ATTACHMENT_TO_MESSAGE } from '../../constants/biEvents';
import { useAttachments } from '../../context/contexts/attachments';
import { DEFAULT_UPLOAD_CONFIG, MAX_FILES } from '../../constants';
import { useReporting } from '../../context/contexts/reporting';
import { useStaticContext } from '../../context/contexts/static';
import EmojiPicker from './EmojiPicker';
import { FileUploader } from './FileUploader';
import AttachmentIcon from './AttachmentIcon';

import classes from './style.module.scss';

export const MessageControls = ({ className }) => {
    const { attachmentsUploadConfig } = useStaticContext();
    const { attachments, upsertAttachment } = useAttachments();
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    const onClick = () => {
        const event = { type: CLICKED_ON_ADD_ATTACHMENT_TO_MESSAGE };

        sendBiEvent(event);
        sendMixpanelEvent(event);
    };

    const uploadConfig = merge({}, DEFAULT_UPLOAD_CONFIG, attachmentsUploadConfig);

    return (
        <div className={classNames('flex', 'flex-items-center', className)}>
            <EmojiPicker/>
            <FileUploader attachments={attachments}
                onAttachmentChange={upsertAttachment}
                className={classes.fileUploadButton}
                onClick={onClick}
                filesLimit={MAX_FILES}
                color={Button.COLORS.WHITE}
                size={Button.SIZES.SMALL}
                options={uploadConfig}
                isDisabled={attachments.length >= MAX_FILES}
                showTitle={false}
                multiple
                icon={AttachmentIcon}/>
        </div>
    );
};

MessageControls.propTypes = {
    className: string
};

export default memo(MessageControls);
